<template>
    <div class="card p-2" style="min-height: 200px">
        <div class="table-responsive">
            <table class="table voucher-list-table">
                <thead>
                    <tr>
                        <th class="col-date">Date</th>
                        <th class="col-voucher">Voucher No</th>
                        <th>Description</th>
                        <th class="col-amount">Amount</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, i) in journals" :key="i">
                        <td class="col-date">
                            <span class="fw-bold">{{ item.date }}</span>
                        </td>
                        <td class="col-voucher">{{ item.voucher_no }}</td>
                        <td> {{item.note}} </td>
                        <td class="col-amount"> {{ commaFormat(item.total_amount) }} </td>
                        <td> {{ startCase(item.status) }} </td>
                        <td>
                            <div class="btn-group">
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary btn-sm rounded-2"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                    style="cursor: pointer;"
                                >
                                    <i class="fas fa-ellipsis-v"></i>
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end">
                                    <li v-if="canEdit(item.status)">
                                        <a class="dropdown-item"
                                           href="#"
                                           @click.prevent="goToEdit(item.id)">
                                            <i class="fas fa-edit me-1"></i> Edit
                                        </a>
                                    </li>
                                    <li v-if="canPrint(item.status)">
                                        <a class="dropdown-item"
                                           href="#"
                                           @click.prevent="goToPrint(item.id)">
                                            <i class="fas fa-print me-1"></i> Print
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </td>
                    </tr>
                    
                </tbody>
            </table>
            <p v-if="!journals.length" class="text-center mt-5">No data</p>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import figureFormatter from '@/services/utils/figureFormatter'
import handlePayment from "@/services/modules/payment";
import handleBarcode from "@/services/modules/barcode";
import ngoPdfPrinter from "@/services/utils/ngoPdfPrinter";
import handleCompany from "@/services/modules/company";
import handleJournal from "@/services/modules/journal";
import { useVoucherPrint } from "@/services/utils/voucherPrint";
import { startCase } from 'lodash';

export default {
    name: 'JournalTable',
    props: {
        customizationPdfFields: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        ...mapGetters ({
            journals: 'journal/getJournals'
        })
    },
    data: () => ({
        barcodeQuery: '',
        barcode: '',
        qrcode: '',
        companyInfo: {}
    }),
    setup() {
        const {commaFormat} = figureFormatter ()
        const {fetchJournal} = handleJournal();
        const { fetchBarcode } = handleBarcode();
        const { exportToPDF, formatDate } = ngoPdfPrinter();
        const { fetchCompanyInfo } = handleCompany();
        const { buildQrcodeText } = useVoucherPrint();

        return {
            formatDate,
            exportToPDF,
            commaFormat,
            fetchBarcode,
            fetchCompanyInfo,
            fetchJournal,
            buildQrcodeText,
            startCase
        }
    },
    methods: {
        canEdit(status) {
            return ['returned', 'return', 'pending', 'pending_approval'].includes(status)
        },
        canPrint(status) {
            return status !== 'rejected'
        },
        goToEdit(id) {
            this.$router.push({name: 'EditJournal', 
                params: {
                    companyId: this.$route.params.companyId,
                    moduleId: this.$route.params.moduleId,
                    menuId: this.$route.params.menuId,
                    pageId: this.$route.params.pageId,
                    journalId: id
                },
                query: {
                    start: this.$route.query.start,
                    end:  this.$route.query.end
                }
            
            })
        },
        goToPrint(id) {
            this.fetchJournal(id).then( (res) => {
                if(res){
                    this.payment = res.data;
                    let qrcodeData = this.buildQrcodeText(this.payment);
                    this.barcodeQuery = `?code=${encodeURIComponent(this.payment.voucher_no)}&qrcode=${encodeURIComponent(qrcodeData)}`;
                }}).then (() => {
                this.fetchBarcode(this.barcodeQuery).then( (res) => {
                    this.barcode = res.barcode;
                    this.qrcode = res.qrcode;
                }).then( () => {
                    this.exportToPDF(this.companyInfo, this.payment, this.barcode, this.qrcode, 'journal', this.customizationPdfFields);
                })})
        }
    },
    mounted() {
        this.fetchCompanyInfo(this.$route.params.companyId).then( (res) => {
            this.companyInfo = res.data;
        }).catch( (err) => {
            console.log(err);
        })
    }
}
</script>

<style scoped>
.voucher-list-table .col-date,
.voucher-list-table .col-voucher,
.voucher-list-table .col-amount {
    white-space: nowrap;
}
.voucher-list-table .col-date {
    min-width: 7.5rem;
}
.voucher-list-table .col-voucher {
    min-width: 8.5rem;
}
.voucher-list-table .col-amount {
    min-width: 9.5rem;
    text-align: right;
}
.voucher-list-table td {
    vertical-align: middle;
}
.table-responsive {
    overflow: visible;
}
.dropdown-menu.show {
    z-index: 1055;
}
</style>
